// import React, { useEffect, useState } from 'react';import React, { useEffect, useState } from 'react';
import { useEffect, useState } from 'react';
import { getAllUsersHistory } from '../../api/Services/masterServie';
import Typography from '@mui/material/Typography';
import { Box, Chip, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

interface HistoryLog {
  historyId: number;
  userId: number;
  module: string;
  action: string;
  createdAt: string;
}

// Define DataHistory interface
interface DataHistory {
  [username: string]: HistoryLog[];  // username -> HistoryLog array
}

const UserHistory: React.FC = () => {
  const [userHistory, setUserHistory] = useState<DataHistory>({});  // Ensure proper typing for the state
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserHistory = async () => {
      try {
        const response = await getAllUsersHistory();
        const { status, data } = response;
  
        if (status.code === 200 && typeof data === 'object' && !Array.isArray(data)) {
          setUserHistory(data); // ✅ Directly use as DataHistory
        } else {
          setError("Failed to load user history.");
        }
      } catch (err) {
        setError("An error occurred while fetching user history.");
      } finally {
        setLoading(false);
      }
    };
  
    fetchUserHistory();
  }, []);
  

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;


return (
  <Box p={2}>
    {Object.entries(userHistory).map(([username, logs]) => (
      <Box key={username} mb={4}>
        <Typography variant="h6" gutterBottom>
          {username}
        </Typography>

        <TableContainer component={Paper} elevation={2}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '25%' }}><strong>Action</strong></TableCell>
                <TableCell sx={{ width: '25%' }}><strong>Module</strong></TableCell>
                <TableCell sx={{ width: '25%' }}><strong>Time</strong></TableCell>
                <TableCell sx={{ width: '25%' }}><strong>Date</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(logs) &&
                logs.map((log: HistoryLog) => {
                  const status = log.action?.toLowerCase();
                  const badgeColor =
                    status === 'excellent'
                      ? 'success'
                      : status === 'well'
                      ? 'primary'
                      : 'warning';

                  return (
                    <TableRow key={log.historyId}>
                      <TableCell>
                        <Chip label={log.action || 'Unknown'} color={badgeColor as any} size="small" />
                      </TableCell>
                      <TableCell>{log.module}</TableCell>
                      <TableCell>{new Date(log.createdAt).toLocaleTimeString()}</TableCell>
                      <TableCell>{new Date(log.createdAt).toLocaleDateString()}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    ))}
  </Box>
);

}




export default UserHistory;
